import classNames from 'classnames';
import {
  createElement,
  forwardRef,
  type ElementType,
  type ReactElement,
  type Ref,
} from 'react';
import type { PolymorphicTableRowProps } from './table.types';

function TableRowInner<C extends ElementType = 'tr'>(
  { children, className, as, ...props }: PolymorphicTableRowProps<C>,
  ref: Ref<Element>,
) {
  const classes = classNames(
    'border-primary-100 border-t-[0.75px]',
    className,
    {
      'hover:bg-primary-50 cursor-pointer': !!props.onClick,
    },
  );
  const Component = as ?? ('tr' as C);
  return createElement(
    Component,
    { className: classes, ref, ...props },
    children,
  );
}

type PolymorphicTableRow = <C extends ElementType = 'tr'>(
  props: PolymorphicTableRowProps<C> & { ref?: Ref<Element> },
) => ReactElement;

export const TableRow = forwardRef(TableRowInner) as PolymorphicTableRow & {
  displayName: string;
};
TableRow.displayName = 'Table.Row';
